import { Box, CircularProgress } from "@material-ui/core";
import useSeasonalMeanSeries from "../../../hooks/charts/useSeasonalMeanSeries";
import SeasonalMeanChart from "./SeasonalMeanChart";

export default function SeasonalMeanChartContainer({
  parameterid,
  startYear,
  endYear = new Date().getFullYear(),
  height = 400,
}) {
  const { raw, series, unit, isLoading, isError } = useSeasonalMeanSeries({
    parameterid,
    startYear,
    endYear,
  });

  if (isLoading) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !series.length) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        No data
      </Box>
    );
  }

  return (
    <SeasonalMeanChart raw={raw} series={series} unit={unit} height={height} />
  );
}
